import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'fourDotFiveTimeFormatPipe'
})
export class FourDotFiveTimeFormatPipe implements PipeTransform {

  transform(value: any): any {
    return moment(value).format("hh:mm a");
  }

}
